import { useEffect, useState } from "react";

const nav = isNavigator ? navigator : undefined;
const conn = nav && (nav.connection || nav.mozConnection || nav.webkitConnection);

function isNavigator(obj) {
  return typeof obj !== 'undefined';
}

function off(target, event, handler) {
  target.removeEventListener(event, handler);
}

function on(target, event, handler, options) {
  target.addEventListener(event, handler, options);
}

function getConnectionState(previousState) {
  const online = isNavigator(nav) ? nav.onLine : undefined;
  const previousOnline = previousState ? previousState.online : undefined;

  return {
    online,
    previous: previousOnline,
    since: online !== previousOnline ? new Date() : (previousState ? previousState.since : undefined),
    downlink: conn ? conn.downlink : undefined,
    downlinkMax: conn ? conn.downlinkMax : undefined,
    effectiveType: conn ? conn.effectiveType : undefined,
    rtt: conn ? conn.rtt : undefined,
    saveData: conn ? conn.saveData : undefined,
    type: conn ? conn.type : undefined,
  };
}

export default function useNetworkState(initialState) {
  const [state, setState] = useState(initialState || getConnectionState());

  useEffect(() => {
    const handleStateChange = () => {
      setState(getConnectionState);
    };

    on(window, 'online', handleStateChange, { passive: true });
    on(window, 'offline', handleStateChange, { passive: true });

    if (conn) {
      on(conn, 'change', handleStateChange, { passive: true });
    }

    return () => {
      off(window, 'online', handleStateChange);
      off(window, 'offline', handleStateChange);

      if (conn) {
        off(conn, 'change', handleStateChange);
      }
    };
  }, []);

  return state;
}
